import React from "react";
import "../style/Awards.css";

const Awards = () => {
  return (
    <div className="awards-container">

      <div className="awards-head">
        <h1>celebrating excellence</h1><br/>
        <p>Our Journey to Becoming the World's #1 Broker</p>
      </div>
      <div className="awards-header">
        <div className="awards-header-item">
        <img  id="aw121" src="images\aw121.png" alt="aw1"/>
          <h3>Best Forex Provider</h3>
          <p>Investors Chronicle & Financial Times Investment and Wealth Management Awards</p>
          <img  id="aw121" src="images\aw117.png" alt="aw1"/>
        </div>
        <div className="awards-header-item">
        <img  id="aw121" src="images\aw121.png" alt="aw1"/>
          <h3>Best Mobile Trading App Global</h3>
          <p>UFAWARDS</p>
          <img  id="aw121" src="images\aw123.png" alt="aw1"/>
        </div>
        <div className="awards-header-item">
        <img  id="aw121" src="images\aw121.png" alt="aw1"/>
          <h3>Best FX Service Provider</h3>
          <p>City of London Wealth Management Awards</p>
          <img  id="aw121" src="images\aw125.png" alt="aw1"/>
        </div>
      </div>

      <div className="awards-banner">
        <div className="award1">
        <h2>At Extrede, we're not just participating in the world of trading; we're leading it.</h2>
        </div>
        <div className="award2">
        <p>
          With over 115 prestigious industry awards, our commitment to excellence has been recognized globally, solidifying our position as the world's #1 broker.
        </p>
        </div>
      </div>

      <div className="awards-stats">
        <div>
        <p>Award Won</p>
          <h3>115</h3>
         
        </div>
        <div>
        <p>Unique Awarding Bodies</p>
          <h3>28</h3>
         
        </div>
        <div>
          
          <p>Different Types of Awards</p>
          <h3>69</h3>
        </div>
      </div>
        

        <div className="colourblue">
      <div className="awards-list">
        <div className="awards-card">
            <img  id="aw21" src="images\aw21.png" alt="aw1"/>
          <h4>Best Forex Provider</h4>
          <p>Online Money Awards</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw12.png" alt="aw1"/>
          <h4>Best Stock CFD Broker in Europe</h4>
          <p>FxEmpire</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw13.png" alt="aw1"/>
          <h4>Best Regulated Forex Broker</h4>
          <p>FxEmpire</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw20.png" alt="aw1"/>
          <h4>Best Mobile Trading App Global</h4>
          <p>UFAWARDS</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw31.png" alt="aw1"/>
          <h4>Best Corporate Social Responsibility</h4>
          <p>Professional Trader Awards</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw11.png" alt="aw1"/>
          <h4>Best Trading Conditions APAC</h4>
          <p>Ultimate Fintech Awards</p>
        </div>




        <div className="awards-card">
        <img  id="aw21" src="images\aw19.png" alt="aw1"/>
          <h4>Best in Class of Algo Trading</h4>
          <p>ForexBrokers.com - 2023</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw2022.png" alt="aw1"/>
          <h4>Best Trading Platform</h4>
          <p>Shares Awards - 2022</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw23.png" alt="aw1"/>
          <h4>Best Value Broker</h4>
          <p>Fazzaco Business Awards - 2022</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw17.png" alt="aw1"/>
          <h4>Most Trusted Broker (Global)</h4>
          <p>Ultimate Fintech Awards - 2021</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw17-1.png" alt="aw1"/>
          <h4>Most Transparent Broker (Global)</h4>
          <p>Ultimate Fintech Awards - 2021</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw17-2.png" alt="aw1"/>
          <h4>Best Broker (UK)</h4>
          <p>Ultimate Fintech Awards - 2021</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw22.png" alt="aw1"/>
          <h4>Best FX Provider</h4>
          <p>Online Personal Wealth Awards - 2021</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw22.png" alt="aw1"/>
          <h4>Best CFD FX Provider</h4>
          <p>Online Personal Wealth Awards - 2021</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw24.png" alt="aw1"/>
          <h4>Best in Class MetaTrader Broker</h4>
          <p>ForexBrokers.com - 2021</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw32.png" alt="aw1"/>

          <h4>Best Corporate Social Responsibility</h4>
          <p>Professional Trader Awards - 2021</p>
        </div>
        {/* <div className="awards-card">
        <img  id="aw21" src="images\aw33.png" alt="aw1"/>
          <h4>Best Brand Brokers</h4>
          <p>huiyou.com - 2021</p>
        </div> */}
        <div className="awards-card">
        <img  id="aw21" src="images\aw15.png" alt="aw1"/>
          <h4>Best Customer Support</h4>
          <p>FxScouts - 2021</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw14.png" alt="aw1"/>
          <h4>Best Trading Platform</h4>
          <p>Shares Awards - 2021</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw16.png" alt="aw1"/>
          <h4>Best Forex Technical Excellence</h4>
          <p>UK Forex Awards - 2021</p>
        </div>
        <div className="awards-card">
        <img  id="aw21" src="images\aw18.png" alt="aw1"/>
          <h4>Best Forex Provider</h4>
          <p>Investors Chronicle & Financial Times Investment and Wealth Management Award - 2021</p>
        </div>

        </div>





      </div>
    </div>
  );
};

export default Awards;
